export var bernoulliDocs = {
  name: 'bernoulli',
  category: 'Probability',
  syntax: ['bernoulli(n)'],
  description: 'The nth Bernoulli number',
  examples: ['bernoulli(4)', 'bernoulli(fraction(12))'],
  seealso: ['combinations', 'gamma', 'stirlingS2']
};